
const connectorWords = new Set([
  "a", "an", "the", "of", "to", "for", "on", "by", "with", "from", "in", "at",
  "and", "or", "but", "if", "because", "&", "is", "are", "was", "were", "has",
  "have", "had", "be", "being", "been", "generally", "usually", "often", "sometimes", "always", "never",
  "such", "that", "which", "who", "whom", "whose", "this", "these", "those", "there", "here",
  "it", "its", "they", "their", "them", "he", "she", "his", "her", "him", "my", "our", "us",
  "you", "made", "about", "as", "like", "just", "so", "than", "then", "now", "will", "shall", "can", "could", "would", "otherwise", "general"
]);

const blockOutEssentialWord = (word) => {
  let maskedWord = '';
  for (const char of word) {
    if (/[a-zA-Z0-9]/.test(char)) {
      maskedWord += '█';
    } else {
      maskedWord += char;
    }
  }
  return `<span class="cloze-placeholder">${maskedWord}</span>`;
};

export const generateClozeHint = (clozeText) => {
  if (!clozeText) return '';
  const tokens = clozeText.split(' ');
  const hintTokens = tokens.map(token => {
    if (!/[a-zA-Z0-9]/.test(token)) {
      return token;
    }
    const cleanToken = token.replace(/[.,/#!$%^&*;:{}=\-_`~()?]/g, "").toLowerCase();

    if (connectorWords.has(cleanToken)) {
      return token;
    } else {
      return blockOutEssentialWord(token);
    }
  });
  return hintTokens.join(' ');
};